import Jump from 'jump.js'
import { easeOutQuad } from 'ez.js';

const scrollToTop = document.querySelector('.js-scroll-to-top');
let timeout;

if (scrollToTop) {
  scrollToTop.addEventListener('click', () => {
    Jump(document.body, {
      duration: 800,
      easing: easeOutQuad,
    });
  });

  window.addEventListener('scroll', () => {
    // debounce to prevent to much event
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      scrollToTop.classList.toggle('is-active', window.scrollY > window.innerHeight);
    }, 100);
  });
}
